/**
 * ToothProtectionScoreCard — оценка за защита на зъба (0-100) с пълната
 * методика (ScoreMethodology) и прогноза какво носи всяка промяна.
 */
import React from "react";
import { Shield } from "lucide-react";
import ScoreMethodology, { BandLine } from "@/components/dental_intel/ScoreMethodology";
import ScoreForecast from "@/components/dental_intel/ScoreForecast";

const BAND_FILL = {
  green: "#22C55E", yellow: "#EAB308", orange: "#F97316", red: "#EF4444",
};

export default function ToothProtectionScoreCard({ data, forecast, isDark, lang = "bg", cardCls }) {
  const score = data?.score ?? 0;
  const color = BAND_FILL[data?.band] || "#EAB308";
  const ex = data?.explain;

  return (
    <div className={`${cardCls} p-5`} data-testid="dhi-tooth-protection-card">
      <div className="flex flex-col md:flex-row gap-5 items-center">
        <div className="relative flex-shrink-0" style={{ width: 140, height: 140 }}>
          <svg width="140" height="140" viewBox="0 0 140 140">
            <circle cx="70" cy="70" r="56" stroke={isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)"}
              strokeWidth="11" fill="none" />
            <circle cx="70" cy="70" r="56" stroke={color} strokeWidth="11"
              strokeLinecap="round" fill="none"
              strokeDasharray={`${(score / 100) * 351.86} 351.86`}
              transform="rotate(-90 70 70)" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <Shield className="w-5 h-5 mb-0.5" style={{ color }} />
            <div className="text-3xl font-extrabold" data-testid="dhi-tooth-protection-score">{score}</div>
            <div className="text-[10px] opacity-60">/ 100</div>
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold mb-0.5">Оценка за защита на зъба</h3>
          <BandLine explain={ex} band={data?.band} testid="dhi-protection-band" />
          <p className="text-xs opacity-70 leading-snug mt-1">
            {ex?.how_bg
              || "Композитен индекс на реминерализация и защита (калций, витамин D, слюнка, киселинно натоварване)."}
          </p>
        </div>
      </div>

      <ScoreMethodology explain={ex} contributors={data?.contributors}
        isDark={isDark} unit="точки" testid="dhi-protection-method" />

      <ScoreForecast forecast={forecast} metric="protection" isDark={isDark}
        testid="dhi-protection-forecast" />
    </div>
  );
}
